import React from 'react';
import classNames from 'classnames';
import { TailwindRoot } from '~/v4/shared/TailwindRoot';
import { Table } from 'v5/design-system/Table';
import {
  getLegacyColumnWidthStyle,
  renderLegacyColumnCell
} from 'v1/components/shared/layout/Tables/legacyColumnCell';
import './TableList.scss';

export default function TableList({
  data = [],
  columns = [],
  vcenter,
  className
}) {
  return (
    <TailwindRoot className="TableList-scrollContainer">
      <div
        className={classNames('TableList', className, {
          TableList_vcenter: vcenter
        })}
      >
        <Table.Root>
          <Table.Header>
            <Table.Row>
              {columns.map((column, columnIndex) => (
                <Table.HeaderCell
                  key={column.id ?? column.accessor ?? columnIndex}
                  style={getLegacyColumnWidthStyle(column)}
                  className="TableList-headerCell"
                >
                  {column.Header}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map((row, rowIndex) => (
              <Table.Row key={row.id ?? rowIndex} className="TableList-row">
                {columns.map((column, columnIndex) => (
                  <Table.Cell
                    key={column.id ?? column.accessor ?? columnIndex}
                    style={getLegacyColumnWidthStyle(column)}
                    className="TableList-td"
                  >
                    {renderLegacyColumnCell(column, row, rowIndex)}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </div>
    </TailwindRoot>
  );
}
